import TeamLineupStatsModel from '../models/TeamLineupStatsModel';
export default {
    model: TeamLineupStatsModel,
    timeout: 30,
    expires: 300,
    pathTemplate: 'api/v1/people?personIds={playerId}&season={season}&hydrate=stats(group=hitting,type=season,season={season},gameType={gameType})'
};
